import {getRequest, postRequest, postRequestReturnVoid} from './apiHelper';

export const buyItemRequest = async (itemType, requestedPrice, balance) => {
    await postRequestReturnVoid('/api/market/buy', {itemType, requestedPrice, balance});
};

export const listAllItemsRequest = async () => {
    return await getRequest('/api/market-state/details');
};

export const addMoneyRequest = async (amount, url) => {
    return await postRequest(`/api/payment/checkout`, {amount, url});
};

export const logoutRequest = async () => {
    await postRequestReturnVoid('/api/auth/logout', {});
};

export const payForUploadedImageRequest = async (file, amount) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('amount', amount);

    const response = await fetch('/api/image/upload', {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    return await response.json();
};

export const fundExistingImage = async (imageId, amount, balance) => {
    return await postRequestReturnVoid('/api/image/fund',
        {imageId, amount, balance});
};

export const getUserTransactionsOverviewRequest = async () => {
    return await getRequest('/api/user-transactions');
};

export const getUserTransactionDetails = async (type) => {
    return await getRequest('/api/user-transactions/' + type);
};

export const googleLoginRequest = async (credential) => {
    const response = await fetch('/api/auth/login/google', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${credential}`,
        },
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    return await response.json();
};

export const purchaseKeyRequest = async (keyCount, balance) => {
    return await postRequestReturnVoid(`/api/lootbox/purchase-key`, {keyCount, balance});
};

export const purchaseLootboxRequest = async () => {
    return await postRequest(`/api/lootbox/purchase-box`, {});
};

export const openLootboxRequest = async (count) => {
    return await postRequest(`/api/lootbox/open/` + count, {});
};

export const getUserProfileRequest = async () => {
    return await getRequest('/api/user/profile');
};

export const setProfileImageRequest = async (imageId) => {
    return await postRequest('/api/user/profile?imageId=' + imageId);
};

export const getTradeDataRequest = async (item) => {
    return await getRequest(`/api/trade-data/${item}`);
};

export const postMessageRequest = async (message, sendAmount, balance) => {
    return await postRequestReturnVoid('/api/chat/message', {message, sendAmount, balance});
};

export const getLastMessagesRequest = async () => {
    return await getRequest('/api/chat/last-50-messages');
};

export const getUnitPriceRequest = async () => {
    return await getRequest('/api/chat/room/unit-price');
};

export const postBuyGraph = async (balance) => {
    return await postRequestReturnVoid('/api/user/graph-item', {balance});
};

export const getOnlineUsersInRoomCount = async () => {
    return await getRequest('/api/chat/room/online-users-without-me');
};

export const postReportMessage = async (messageId, reason, description, type) => {
    return await postRequestReturnVoid('/api/report-message', {messageId, reason, description, type});
};

export const genericSellRequest = async (itemType, quantity, price) => {
    return await postRequestReturnVoid('/api/market/generic-sell-offer', {itemType, quantity, price});
};

export const createBuyOfferRequest = async (itemType, quantity, price, balance) => {
    return await postRequestReturnVoid('/api/market/generic-buy-offer', {itemType, quantity, price, balance});
};


export const getUserInfoRequest = async (userId) => {
    return await getRequest('/api/user/user-info/' + userId);
};

export const getBuyOffersRequest = async (itemType) => {
    return await getRequest('/api/market-state/buy-offers/' + itemType);
};

export const getSellOffersRequest = async (itemType) => {
    return await getRequest('/api/market-state/sell-offers/' + itemType);
};

export const listAllPicturesRequest = async () => {
    return await getRequest('/api/pictures');
};

export const getPictureRequest = async (pictureId) => {
    return await getRequest('/api/pictures/' + pictureId);
};


export const sellItemToUserRequest = async (itemType, price, userId) => {
    return await postRequestReturnVoid('/api/market/sell-to-user', {itemType, price, userId});
};

export const buyItemFromUserRequest = async (itemType, price, userId, balance) => {
    return await postRequestReturnVoid('/api/market/buy-from-user', {itemType, price, userId, balance});
};

export const getCommentsRequest = async (pictureId) => {
    return await getRequest('/api/picture/comment/' + pictureId);
};

export const commentPictureRequest = async (pictureId, comment, balance) => {
    return await postRequestReturnVoid('/api/picture/comment', {pictureId, comment, balance});
};

export const replyCommentPictureRequest = async (pictureId, responseTo, comment, balance) => {
    return await postRequestReturnVoid('/api/picture/comment', {pictureId, responseTo, comment, balance});
};

export const getAllNotificationsRequest = async () => {
    return await getRequest('/api/user-notifications');
};

export const getNotificationsPreviewRequest = async () => {
    return await getRequest('/api/user-notifications/preview');
};

export const notificationReadRequest = async (id) => {
    return await postRequestReturnVoid('/api/user-notifications/read/' + id, {});
};

export const notificationReadElusiveRequest = async (id, unreadIds) => {
    return await postRequest('/api/user-notifications/read-elusive', {id, unreadIds});
};

export const loginWithEmail = async (email) => {
    return await postRequest('/api/auth/login/email', {email});
};

export const registerWithEmail = async (email) => {
    return await postRequest('/api/auth/register/email', {email});
};

export const verifyLoginWithEmail = async (verificationId, verificationSecret) => {
    return await postRequest('/api/auth/login/verify', {verificationId, verificationSecret});
};

export const setNicknameRequest = async (nickname, currentPath) => {
    return await postRequestReturnVoid('/api/auth/set-nickname', {nickname, currentPath});
};

export const reactToCommentRequest = async (commentId, reactionType, price, balance) => {
    return await postRequestReturnVoid('/api/picture/comment/reaction', {commentId, reactionType, price, balance});
};

export const getDetailedReactionsRequest = async (commentId) => {
    return await getRequest('/api/picture/comment/reactions/' + commentId);
};

export const markAllAsReadRequest = async () => {
    return await postRequest('/api/user-notifications/read-all', {});
};

export const pinCommentRequest = async (commentId, balance) => {
    return await postRequestReturnVoid('/api/picture/comment/pin', {commentId, balance});
};

export const getIgnoredNotificationsRequest = async () => {
    return await getRequest('/api/user-notifications/ignored-count');
};

export const resetIgnoredNotificationsRequest = async () => {
    return await postRequestReturnVoid('/api/user-notifications/ignored-count/reset', {});
}

export const postCharityLink = async (link) => {
    return await postRequestReturnVoid('/api/charity-link/send', {link});
};

export const getMyLinks = async () => {
    return await getRequest('/api/charity-link/my-links');
};

export const getPublicLinks = async () => {
    return await getRequest('/api/charity-link/public');
};

export const canDonateRequest = async () => {
    return await getRequest('/api/charity-link/can-donate');
}

export const cancelCharityLinkRequest = async (linkId) => {
    return await postRequestReturnVoid('/api/charity-link/cancel/' + linkId);
}